import { PDFViewer } from "@react-pdf/renderer";
import React, { useContext, useState } from "react";
import { Pdf } from "../Pdf";
import { ResultContext } from "../ResultContext";
import { GraphMaker } from "./GraphMaker";
import "./Deliverables.css";
import axios from "axios";
import { AiFillPlusCircle } from "react-icons/ai";
import { FaTrash } from "react-icons/fa";

export function Deliverables() {
  const [image, setImage] = useState("");
  const [emails, setEmails] = useState<string[]>([""]);
  const [status, setStatus] = useState("");
  const { result } = useContext(ResultContext);
  const previewWidth = 700;

  const addMail = () => {
    setEmails([...emails, ""]);
  };

  return (
    <>
      <div className="flex flex-row justify-center deliverablesContainer">
        <div className="requestPDFContainer">
          <div className="title">Request your PDF</div>
          <label className="flex mt-4">Mail address</label>
          {emails.map((item, index) => {
            return (
              <div className="flex" key={index}>
                <input
                  type="text"
                  id="mail"
                  required
                  placeholder="founder@mail.com"
                  value={emails[index]}
                  onChange={(e) => {
                    const newEmailList = [...emails];
                    newEmailList[index] = e.target.value;
                    setEmails(newEmailList);
                  }}
                />
                <AiFillPlusCircle
                  className="plus-icon pointer"
                  onClick={addMail}
                />
                {index > 0 ? (
                  <FaTrash
                    className="thrash-icon pointer"
                    onClick={() => {
                      const newEmailList = [...emails];
                      newEmailList.splice(index, 1);
                      setEmails(newEmailList);
                    }}
                  />
                ) : null}
              </div>
            );
          })}
          <div
            className="button mail"
            onClick={async () => {
              await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/documents`,
                { email: emails, document: result }
              );
              setStatus("Mail sent!");
            }}
          >
            Request pdf
          </div>
          <div>{status}</div>
          <div className="title mt-12"> Next steps?</div>
          <div className="paragraph">
            If you are interested in translating this intellectual exercise into
            a tailored and legally secure document (which can be a binding term
            sheet or a fully-fledged shareholders’ agreement), feel free to
            contact us via{" "}
            <a href={"mailto:info@mace-legal.com"}>info@mace-legal.com</a>.
          </div>
          <div className="paragraph">
            Typically such document would also tackle other shareholder
            arrangements related to the transfers of shares (restrictions & free
            transfers), the governance of the company (the board, reserved
            matters...), certain restrictive covenants (non-compete,
            non-solicit...), and more. This entails thus a more comprehensive
            intellectual exercise as the one provided for in the DER 9000 tool.
          </div>
        </div>
        <div className="pdfContainer">
          {image !== "" ? (
            <div>
              <div className="title">PDF preview</div>
              <PDFViewer
                width={`${previewWidth}px`}
                height={`${previewWidth / 1.4}px`}
              >
                <Pdf result={result} image={image} />
              </PDFViewer>
            </div>
          ) : null}
        </div>
      </div>
      <GraphMaker setImage={setImage} />
    </>
  );
}
